import './App.css';
import ContentLayout from './ContentLayout';

function FamilyTree() {
  return (
    <ContentLayout
      title="Malam Family Tree"
      intro="A family-history section for the Malam line."
      heroImage="/banners/family_banner.png"
    >
      <div className="content-body">
        <p>Coming soon</p>
      </div>
    </ContentLayout>
  );
}

export default FamilyTree;
